export default "__VITE_ASSET__oXhz5XE9__"